import React, { useRef } from 'react'
import { ReactTags, type TagSuggestion, type TagSelected, type ReactTagsAPI } from 'react-tag-autocomplete'
import './style.sass'

type Tag = {
	id: string | number
	name: string
	[prop: string]: any
}

type Props = {
	placeholderText: string
	ariaLabelText: string
	tags: Tag[]
	label: string
	suggestions: Tag[]
	onDelete: (i: number) => void
	onAddition: (tag: Tag) => void
	onInput: (query: string) => void
	minQueryLength?: number
}

function toSelected(tags: Tag[]): TagSelected[] {
	return tags.map(t => ({ value: t.id, label: t.name }))
}

function toSuggestions(suggestions: Tag[]): TagSuggestion[] {
	return suggestions.map(s => ({ value: s.id, label: s.name, disabled: s.disabled ?? false }))
}

export default function TagComponent(props: Props): React.ReactNode {
	const reactTagsRef = useRef<ReactTagsAPI>(null)
	const { placeholderText, ariaLabelText, tags, suggestions, onDelete, onAddition, onInput, label, minQueryLength = 1 } = props

	const handleAdd = (tag: TagSelected) => {
		const original = suggestions.find(s => s.id === tag.value) ?? { id: tag.value, name: tag.label }
		onAddition(original as Tag)
	}

	return (
		<div className='TagsComponent__Container'>
			<p className='TagsComponent__Container__Label'>{label}</p>
			<ReactTags
				labelText={ariaLabelText}
				placeholderText={placeholderText}
				ref={reactTagsRef}
				selected={toSelected(tags)}
				suggestions={toSuggestions(suggestions)}
				onDelete={onDelete}
				onAdd={handleAdd}
				onInput={onInput}
				onShouldExpand={(value) => value.length >= minQueryLength}
			/>
		</div>
	)
}
